import { render, staticRenderFns } from "./BirthdayLogs.vue?vue&type=template&id=74382df8&"
import script from "./BirthdayLogs.vue?vue&type=script&lang=js&"
export * from "./BirthdayLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports